import React from 'react';

/**
 * TextArea Component
 * Reusable textarea with label and error message
 */
const TextArea = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  error,
  touched,
  required = false,
  disabled = false,
  rows = 4,
  maxLength,
  showCount = false,
  helper,
  className = '',
  textareaClassName = '',
  ...props
}) => {
  const hasError = touched && error;
  const textareaId = props.id || `textarea-${name}`;
  const currentLength = value?.length || 0;

  return (
    <div className={`mb-4 ${className}`}>
      {/* Label */}
      <div className="flex items-center justify-between mb-2">
        {label && (
          <label htmlFor={textareaId} className="label mb-0">
            {label}
            {required && <span className="text-red-500 ml-1">*</span>}
          </label>
        )}
        {showCount && maxLength && (
          <span className="text-sm text-bukawa-gray-500">
            {currentLength}/{maxLength}
          </span>
        )}
      </div>

      {/* Textarea field */}
      <textarea
        id={textareaId}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        rows={rows}
        maxLength={maxLength}
        className={`
          ${hasError ? 'input-error' : 'input'}
          ${disabled ? 'bg-bukawa-gray-100 cursor-not-allowed' : ''}
          resize-y
          ${textareaClassName}
        `.trim().replace(/\s+/g, ' ')}
        aria-invalid={hasError ? 'true' : 'false'}
        aria-describedby={
          hasError ? `${textareaId}-error` : helper ? `${textareaId}-helper` : undefined
        }
        {...props}
      />

      {/* Helper text */}
      {helper && !hasError && (
        <p
          id={`${textareaId}-helper`}
          className="mt-1 text-sm text-bukawa-gray-500"
        >
          {helper}
        </p>
      )}

      {/* Error message */}
      {hasError && (
        <p
          id={`${textareaId}-error`}
          className="mt-1 text-sm text-red-600"
          role="alert"
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default TextArea;